import {
  Autocomplete,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import { CompanyItem, ContentStatus, CourseForm } from '../model';

type CompanyAccessForm = Pick<CourseForm, 'isForAllCompanies' | 'companyIds'>;

type Props = {
  form: CompanyAccessForm;
  companies: CompanyItem[];
  onChange: (form: CompanyAccessForm) => void;
};

export const CompanyAccessFields = ({ form, companies, onChange }: Props) => {
  const selectedCompanies = companies.filter((company) =>
    form.companyIds.includes(company.id),
  );

  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={form.isForAllCompanies}
            onChange={(e) => {
              const checked = e.target.checked;
              onChange({
                ...form,
                isForAllCompanies: checked,
                companyIds: checked ? [] : form.companyIds,
              });
            }}
          />
        }
        label="Доступно всем компаниям"
      />

      {!form.isForAllCompanies && (
        <Autocomplete
          multiple
          disableCloseOnSelect
          options={companies}
          value={selectedCompanies}
          isOptionEqualToValue={(option, value) => option.id === value.id}
          getOptionLabel={(option) => option.name}
          onChange={(_, value) => {
            onChange({ ...form, companyIds: value.map((item) => item.id) });
          }}
          renderInput={(params) => (
            <TextField {...params} label="Компании" placeholder="Выберите" />
          )}
        />
      )}
    </>
  );
};

type StatusSelectProps = {
  value: ContentStatus;
  onChange: (status: ContentStatus) => void;
};

export const StatusSelect = ({ value, onChange }: StatusSelectProps) => (
  <FormControl fullWidth>
    <InputLabel id="content-status-label">Статус</InputLabel>
    <Select
      labelId="content-status-label"
      label="Статус"
      value={value}
      onChange={(e) => onChange(e.target.value as ContentStatus)}
    >
      <MenuItem value="draft">Черновик</MenuItem>
      <MenuItem value="published">Опубликовано</MenuItem>
    </Select>
  </FormControl>
);
